import { GetStaticPropsResult } from 'next'

import { SanitySiteFragment } from '@data/sanity/queries/types/site'
import { SanityShopPage } from '@data/sanity/queries/types/page'
import { getShopifyDomain } from '@lib/shopify/client'
import { getPreview } from '@lib/sanity/client'
import { getShopIndexPage } from '@lib/sanity/page'
import { Locale } from '@lib/language'
import { getReviews, Reviews } from '@lib/review'
import { CustomStaticPropsContext } from '@lib/routes'

import Modules from '@modules/modules'
import Layout from '@components/layout'

interface ShopPageProps {
  locale: Locale
  page: SanityShopPage
  site: SanitySiteFragment
  reviews?: Reviews
}

const ShopPage = ({ page, site, reviews }: ShopPageProps) => (
  <Layout page={page} site={site}>
    <Modules
      modules={page.modules}
      collectionProducts={page.products}
      featuredProductIds={page.featuredProductIds}
      reviews={reviews}
    />
  </Layout>
)

export async function getStaticProps({
  locale,
  preview,
  previewData,
}: CustomStaticPropsContext): Promise<GetStaticPropsResult<ShopPageProps>> {
  const shopIndexPage = await getShopIndexPage(
    locale,
    getPreview(preview, previewData)
  )

  if (!shopIndexPage.page) {
    return { notFound: true }
  }

  // Get Stamped.io reviews
  const shopifyDomain = getShopifyDomain(locale)
  const reviews = await getReviews(
    shopIndexPage.page.modules ?? [],
    shopifyDomain,
    shopIndexPage.site.settings.stampedApiKey
  )

  return {
    props: {
      locale,
      page: shopIndexPage.page,
      site: shopIndexPage.site,
      reviews,
    },
    revalidate: 60,
  }
}

export default ShopPage
